import { Component, Input } from '@angular/core';

@Component({
  selector: 'l-list-header',
  standalone: true,
  templateUrl: './list-header.component.html',
})
export class ListHeaderComponent {

  @Input()
  public title: string = '|';

  @Input()
  public subtitle: string = '';

}
